/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import React, { Component } from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";
import { createMessageFactory } from "../../utils/i18n";
import { connectTeamsComponent, ThemeStyle } from 'msteams-ui-components-react';
import { ActionButton, IIconProps } from 'office-ui-fabric-react';
import { bannerStyles } from './styles';
import openLinkThroughIframe from '../../utils/linkHelper';

const msg = createMessageFactory("app-validation-banner");

type Props = InjectedIntlProps & any;

class Banner extends Component<Props, any> {

  constructor(props: any) {
    super(props);

    this.state = {
      styles: this.styles(),
      showBanner: true,
    };

    this.hideBanner = this.hideBanner.bind(this);
  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.context.style !== prevProps.context.style) {
      this.setState({ styles: this.styles() });
    }
  }

  public styles = () => {
    const themedColors = this.colors();

    return bannerStyles(themedColors)
  }

  private colors = () => {
    const { context } = this.props;

    switch (context.style) {
      case ThemeStyle.HighContrast:
        return {
        };
      case ThemeStyle.Dark:
        return {
          bannerBackground: 'rgb(59, 58, 57)',
          bannerTextColor: 'rgb(255, 255, 255)',
          bannerCloseColor: 'rgb(223, 222, 222)',
        };
      case ThemeStyle.Light:
      default:
        return {
          bannerBackground: 'rgb(237, 235, 233)',
          bannerTextColor: 'rgb(72, 70, 68)',
          bannerCloseColor: 'rgb(72, 70, 68)',
        };
    }
  }

  public render(): JSX.Element {
    const { intl } = this.props;

    const styles = this.state.styles;
    const сhromeClose: IIconProps = { iconName: 'ChromeClose' };
    const surveyLink = 'https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbR9-Blv0KtMpMu2GNZYjE5bZUMzdJMlJTVFBEUEdPSldYN05WNFYwUDJTOS4u';

    return (
      <div aria-live="polite"
        style={{ 'visibility': this.state.showBanner ? 'visible' : 'hidden' }}
        aria-hidden={!this.state.showBanner}
        className={styles.common.topBanner} >
        <div>
          <FormattedMessage
            {...msg({
              id: "top-banner",
              defaultMessage: "This is a preview version of App Validator. To help us make it better, please take "
            })}
          />
          <a
            target="_blank"
            aria-label={intl.formatMessage(msg({ id: 'app-validation-survey', defaultMessage: 'take a quick survey' }))}
            onClick={() => openLinkThroughIframe(surveyLink)}
            href={surveyLink}>
            a quick survey
          </a>
        </div>
        <span tabIndex={0}>
          <ActionButton
            aria-label={intl.formatMessage(msg({ id: 'close-banner', defaultMessage: 'close the banner for survey' }))}
            onClick={this.hideBanner}
            iconProps={сhromeClose}>
          </ActionButton>
        </span>
      </div>
    );
  }

  private hideBanner() {
    this.setState({ showBanner: false });
  }
}

export default injectIntl(connectTeamsComponent(Banner));
